//we use this id for create unic name for multiselect
//only used for the ac selection



var creditedPurchase = 0
export function providercredit_vs_credited_purchase(id) {
	creditedPurchase++

	return `

	<div class="line line-${id} " lineId="${id}" id="providercredit_form_credited_purchase_mt_${creditedPurchase}">   

	    <div class="row">

			<div class="c50">

 				<div class="row">
					<div class="c20">

						<div class="checkbox checkbox-mini add_credited_amount"> 
							<input type="checkbox" class="elem" data-detail='{"click":[{"dest":"ripple" },
										{"dest":"providercredit", "elem":"fullcont",  "id":"providercredit-fullcont", "act":"addAmountCredited"}]}'> 
							<label>ADD</label>
						</div><!-- checkbox -->  

					</div><!-- c20 --> 
		
					<div class="c75">

						<div class="textfield  textfield-autocomplete textfield-autocomplete-mini textfield-autocomplete-disabled purchase_id" 
														id="providercredit_form_credited_purchase_id_mt_${creditedPurchase}" selected = '[]'  max = '1'>

							<input autocomplete="off"  class= 'elem' type="text" 
								data-detail='{
								"key": [   {"dest":"textfield",    "act":"typing" }, 
											{"dest":"autocomplete", "act":"typing",  "entity": "sale", "mainFilter": ["code"], "parent": "providercredit_form_purchaseid_mt_${creditedPurchase}"   }],
								"click": [ {"dest":"autocomplete", "act":"click",   "entity": "sale", "mainFilter": ["code"], "parent": "providercredit_form_purchaseid_mt_${creditedPurchase}"   }]
								}' readonly>
								
							<div class="chip-cont"></div>
							<!-- otherField is used for autocomplete other fields, different than id and displayText -->  
							<div class="dn otherField" data-detail='{}' ></div>

						</div> <!-- textfield --> 

					</div><!-- c25 --> 
				</div><!-- row --> 

			</div>


			<div class="c50">
		

				<div class="row">
					<div class="c33">

						<div class="textfield textfield-cash  textfield-mini textfield-disabled po_total_amount "  >

							<input autocomplete="off"  class= 'elem' type="text"  placeholder="Po Total Amoun" 
							data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' readonly>

						</div><!-- textfield -->  

					</div><!-- c25 --> 

					<div class="c33">

						<div class="textfield textfield-cash  textfield-mini textfield-disabled available_credit"  >

							<input autocomplete="off"  class= 'elem' type="text" placeholder="Credit Available" 
							data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' readonly>

						</div><!-- textfield -->  

					</div><!-- c25 --> 

				
					<div class="c33">

						<div class="textfield textfield-cash  textfield-mini used_credit"  >

							<input autocomplete="off"  class= 'elem' type="text"  placeholder="Credit to use" 
							data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  } ,
													{"dest":"providercredit", "elem":"fullcont",  "act":"keyValueCredited"} ] }' >

						</div><!-- textfield -->  

					</div><!-- c25 --> 
				</div><!-- row --> 

			</div>	



	    </div><!-- row -->

	</div><!-- line -->  
	`

}


var radioUnicId = 0
export function providercredit_vs_paid_purchase(id) {

	radioUnicId++
	return `

	<div class="line line-${id} " lineId="${id}" id="providercredit_form_mt_${radioUnicId}">   

	    <div class="row">

			<div class="c50">

				<div class="row">
					<div class="c20">
						<div class="checkbox checkbox-mini add_amount"> 
							<input type="checkbox" class="elem" data-detail='{"click":[{"dest":"ripple" },
										{"dest":"providercredit", "elem":"fullcont",  "id":"providercredit-fullcont", "act":"addAmount" , "line":"${radioUnicId}"}]}'> 
							<label>ADD</label>
						</div><!-- checkbox -->  
					</div><!-- c25 --> 
		
					<div class="c75">
						
						<div class="textfield  textfield-autocomplete textfield-autocomplete-mini textfield-autocomplete-disabled purchase_id" 
																id="providercredit_form_purchaseid_mt_${radioUnicId}" selected = '[]'  max = '1'>

							<input autocomplete="off"  class= 'elem' type="text" 
								data-detail='{
								"key": [   {"dest":"textfield",    "act":"typing" }, 
											{"dest":"autocomplete", "act":"typing",  "entity": "purchase", "mainFilter": ["code"], "parent": "providercredit_form_purchaseid_mt_${radioUnicId}"   }],
								"click": [ {"dest":"autocomplete", "act":"click",   "entity": "purchase", "mainFilter": ["code"], "parent": "providercredit_form_purchaseid_mt_${radioUnicId}"   }]
								}' readonly>
								
							<div class="chip-cont"></div>
							<!-- otherField is used for autocomplete other fields, different than id and displayText -->  
							<div class="dn otherField" data-detail='{}' ></div>
						</div> <!-- textfield --> 

					</div><!-- c25 --> 

				</div><!-- row --> 

			</div><!-- c75 --> 

			<div class="c50">
	   

 				<div class="row">
					<div class="c33">

						<div class="textfield textfield-cash  textfield-mini textfield-disabled po_total_amount "  >
							<input autocomplete="off"  class= 'elem' type="text"  placeholder="Po Total Amoun" 
							data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' readonly>

						</div><!-- textfield -->  
					</div><!-- c25 --> 

					<div class="c33">

						<div class="textfield textfield-cash  textfield-mini textfield-disabled due_amount"  >
							<input autocomplete="off"  class= 'elem' type="text" placeholder="Due Amount" 
							data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' readonly>
						</div><!-- textfield -->  

					</div>

					<div class="c33">

						<div class="textfield textfield-cash  textfield-mini sent_amount"  >

							<input autocomplete="off"  class= 'elem' type="text"  placeholder="Sent Amount" 
							data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  } ,
													{"dest":"providercredit", "elem":"fullcont",  "act":"keyValueSent","id_item_ac":"${radioUnicId}"} ] }' >

						</div><!-- textfield -->  

					</div><!-- c25 --> 
				</div><!-- row --> 

			</div><!-- c25 --> 

	    </div><!-- row -->

	</div><!-- line -->  
	`

}



